import * as React from "react";
const SkaiStarsSvg = (props) => (
  <svg
    width={65}
    height={71}
    viewBox="0 0 65 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.218 11.48c1.919-5.615 9.677-5.785 11.951-.51l.193.512 2.589 7.572a12.83 12.83 0 0 0 7.302 7.736l.696.26 7.572 2.585c5.615 1.919 5.785 9.677.513 11.951l-.513.193-7.572 2.589a12.83 12.83 0 0 0-7.738 7.302l-.26.693-2.586 7.575c-1.919 5.615-9.676 5.785-11.948.513l-.199-.513-2.586-7.572a12.83 12.83 0 0 0-7.302-7.738l-.693-.26-7.571-2.586c-5.618-1.918-5.788-9.676-.514-11.948l.514-.199 7.571-2.586a12.83 12.83 0 0 0 7.735-7.302l.26-.693zm6.074 2.072-2.586 7.572A19.25 19.25 0 0 1 15.509 32.83l-.802.292-7.572 2.586 7.572 2.586a19.25 19.25 0 0 1 11.707 11.197l.292.802 2.586 7.571 2.586-7.571a19.25 19.25 0 0 1 11.197-11.707l.802-.29 7.571-2.588-7.571-2.586a19.25 19.25 0 0 1-11.708-11.197l-.288-.802zM54.958.417a3.21 3.21 0 0 1 2.881 1.797l.154.375 1.123 3.292 3.295 1.123a3.208 3.208 0 0 1 .379 5.92l-.379.153L59.12 14.2l-1.123 3.295a3.208 3.208 0 0 1-5.92.375l-.154-.375-1.123-3.292-3.295-1.123a3.208 3.208 0 0 1-.378-5.92l.378-.153 3.292-1.123 1.123-3.295A3.21 3.21 0 0 1 54.958.417"
      fill="#171717"
    />
  </svg>
);
export default SkaiStarsSvg;
